import api from "../../Environment";

/**
 * Sprint 9 Phase B — Channel / EPG / Broadcast Ops API helpers.
 */

async function post(action, params = {}) {
  const response = await api.postMethod(action, params);
  return (response && response.data) || { success: false };
}

export async function fetchChannels(params = {}) {
  const body = await post("channels", params);
  if (!body.success) return [];
  return (body.data && body.data.channels) || [];
}

export async function fetchChannelNow(params = {}) {
  const body = await post("channels/now", params);
  return body;
}

/** Schedule preview — dry-run what airs at a given time (uses channels/now resolver). */
export async function previewScheduleAt(params = {}) {
  return fetchChannelNow(params);
}

export async function fetchEpg(params = {}) {
  const body = await post("channels/epg", params);
  if (!body.success) return null;
  return body.data;
}

export async function fetchTimeline(params = {}) {
  const body = await post("channels/timeline", params);
  if (!body.success) return null;
  return body.data;
}

export async function saveScheduleEntry(params = {}) {
  return post("channels/entries/save", params);
}

export async function deleteScheduleEntry(id) {
  return post("channels/entries/delete", { id });
}

export async function fetchOpsDashboard(params = {}) {
  const body = await post("channels/ops", params);
  if (!body.success) return null;
  return body.data;
}

export async function liveAction(params = {}) {
  return post("channels/live-action", params);
}

export async function fetchPlayoutClock(params = {}) {
  const body = await post("channels/playout-clock", params);
  if (!body.success) return null;
  return body.data;
}

export async function fetchBroadcastOutputs(params = {}) {
  const body = await post("channels/outputs", params);
  if (!body.success) return null;
  return body.data;
}

export async function materializeSchedule(params = {}) {
  return post("channels/materialize", params);
}

export async function runAutomation(params = {}) {
  return post("channels/automate", params);
}

export async function fetchTemplates(params = {}) {
  const body = await post("channels/templates", params);
  if (!body.success) return [];
  return (body.data && body.data.templates) || [];
}

export async function applyTemplate(params = {}) {
  return post("channels/templates/apply", params);
}

export async function saveChannel(params = {}) {
  return post("channels/save", params);
}

export async function trackBroadcastEvent(params = {}) {
  return post("channels/analytics/track", params);
}

export async function fetchAnalyticsSummary(params = {}) {
  const body = await post("channels/analytics/summary", params);
  if (!body.success) return null;
  return body.data;
}

export async function fetchAlerts(params = {}) {
  const body = await post("channels/alerts", params);
  if (!body.success) return [];
  return (body.data && body.data.alerts) || [];
}

const FAV_KEY = "tpg_channel_favorites";
const RECENT_KEY = "tpg_channel_recent";

export function getFavoriteChannelIds() {
  try {
    return JSON.parse(localStorage.getItem(FAV_KEY) || "[]");
  } catch (e) {
    return [];
  }
}

export function toggleFavoriteChannel(channelId) {
  const id = String(channelId);
  let list = getFavoriteChannelIds();
  if (list.indexOf(id) >= 0) {
    list = list.filter((x) => x !== id);
  } else {
    list = [id].concat(list).slice(0, 40);
  }
  localStorage.setItem(FAV_KEY, JSON.stringify(list));
  return list;
}

export function getRecentChannelIds() {
  try {
    return JSON.parse(localStorage.getItem(RECENT_KEY) || "[]");
  } catch (e) {
    return [];
  }
}

export function pushRecentChannel(channelId) {
  const id = String(channelId);
  const list = [id].concat(getRecentChannelIds().filter((x) => x !== id)).slice(0, 20);
  localStorage.setItem(RECENT_KEY, JSON.stringify(list));
  return list;
}
